import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import getIn from 'immutable-less/transmute/getIn';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITruncateString from 'UIComponents/text/UITruncateString';
import Small from 'UIComponents/elements/Small';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';

// TODO partially typed until we've found a good `Reference` type
import { jsx as _jsx } from "react/jsx-runtime";
class MarketingStatus extends PureComponent {
  render() {
    const {
      reference
    } = this.props;
    const hsMarketableStatus = getIn(['referencedObject', 'properties', 'hs_marketable_status', 'value'], reference);
    if (!hsMarketableStatus) {
      return null;
    }
    return hsMarketableStatus === 'false' && /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(UITruncateString, {
        useFlex: true,
        tooltip: false,
        fixedChildren: /*#__PURE__*/_jsx(UITooltip, {
          use: "longform",
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.history.log-events.non-marketing-status"
          }),
          title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            options: {
              supportKey: SupportLinkKeys.SET_CONTACT_AS_MARKETING
            },
            elements: {
              DocButton
            },
            message: "automation-ui-enrollment.history.log-events.non-marketing-status-info_jsx"
          }),
          placement: "bottom",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "info",
            className: "m-left-1",
            size: 12
          })
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.history.log-events.non-marketing-status"
        })
      })
    });
  }
}
MarketingStatus.propTypes = {
  reference: PropTypes.object.isRequired
};
export default MarketingStatus;